import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import logo from './logo.png';
import { ROUTES, useI18n, usePageTitle } from './i18n';

export default function SmsOptIn() {
  const [dob, setDob] = useState({ day: '', month: '', year: '' });
  const [phone, setPhone] = useState('');
  const { messages, localizePath } = useI18n();
  const copy = messages.smsOptIn;

  usePageTitle(copy.metaTitle);

  return (
    <div className="App">
      <header className="App-header" style={{ paddingTop: 40 }}>
        <img src={logo} className="sms-logo" alt="7Loves Logo" />

        <h1 className="title">{copy.title}</h1>

        <p className="subtitle" style={{ maxWidth: 400, lineHeight: 1.4 }}>
          {copy.subtitle}
        </p>

        <div style={{ marginTop: 30, width: '100%', maxWidth: 320 }}>
          <label
            style={{
              fontSize: 14,
              fontWeight: '600',
              marginBottom: 8,
              display: 'block',
              textAlign: 'left',
            }}
          >
            {copy.dobLabel}
          </label>

          <div style={{ display: 'flex', gap: 10 }}>
            <input
              type="number"
              placeholder={copy.dayPlaceholder}
              className="App-input"
              style={{ width: '30%' }}
              value={dob.day}
              onChange={(event) =>
                setDob((currentDob) => ({ ...currentDob, day: event.target.value.slice(0, 2) }))
              }
            />
            <input
              type="number"
              placeholder={copy.monthPlaceholder}
              className="App-input"
              style={{ width: '30%' }}
              value={dob.month}
              onChange={(event) =>
                setDob((currentDob) => ({ ...currentDob, month: event.target.value.slice(0, 2) }))
              }
            />
            <input
              type="number"
              placeholder={copy.yearPlaceholder}
              className="App-input"
              style={{ width: '40%' }}
              value={dob.year}
              onChange={(event) =>
                setDob((currentDob) => ({ ...currentDob, year: event.target.value.slice(0, 4) }))
              }
            />
          </div>
        </div>

        <div style={{ marginTop: 25, width: '100%', maxWidth: 320 }}>
          <label
            style={{
              fontSize: 14,
              fontWeight: '600',
              marginBottom: 8,
              display: 'block',
              textAlign: 'left',
            }}
          >
            {copy.phoneLabel}
          </label>
          <input
            type="tel"
            placeholder={copy.phonePlaceholder}
            className="App-input"
            style={{ width: '100%' }}
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
          />
        </div>

        <button
          type="button"
          className="App-button App-button-primary"
          style={{ marginTop: 35 }}
          onClick={() => {}}
        >
          {copy.sendCode}
        </button>

        <p className="sms-disclosure">{copy.disclosure}</p>

        <Link to={localizePath(ROUTES.privacy)} className="sms-privacy-link">
          {copy.privacyLink}
        </Link>
      </header>
    </div>
  );
}
